module.exports = __webpack_public_path__ + "media/localization/turkish-8f82be2f.png";